import { render } from "./CarouselContainerProduction.vue.js?vue&type=template&id=108164a8!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CarouselContainerProduction.vue?vue&type=template&id=108164a8"
import script from "./CarouselContainerProduction.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CarouselContainerProduction.vue?vue&type=script&lang=js"
export * from "./CarouselContainerProduction.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CarouselContainerProduction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/layouts/CarouselContainerProduction.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "108164a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('108164a8', __exports__)) {
    api.reload('108164a8', __exports__)
  }
  
  module.hot.accept("./CarouselContainerProduction.vue.js?vue&type=template&id=108164a8!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CarouselContainerProduction.vue?vue&type=template&id=108164a8", () => {
    api.rerender('108164a8', render)
  })

}


export default __exports__